@if (season(); as s) {
  <article class="atmos-season-card atmos-card">
    @if (sections()['img']) {
      <div class="atmos-season-card__media">
        @if (s.imageUrl) {
          <div class="atmos-season-card__image" [style.background-image]="imageStyle()"></div>
        } @else {
          <div class="atmos-season-card__image atmos-season-card__image--fallback"></div>
        }
        <div class="atmos-season-card__fade"></div>
        <div class="atmos-season-card__heading">
          <div class="atmos-season-card__kicker">Season {{ s.number }} · {{ s.year }} Q{{ quarter() }}</div>
          <h2 class="atmos-season-card__title">
            <a class="atmos-season-card__title-link atmos-focus-ring" [routerLink]="['/season', s.guid]">{{ s.name }}</a>
          </h2>
        </div>
      </div>
    }

    <div class="atmos-season-card__body atmos-card__body">
      @if (sections()['overview']) {
        <a class="atmos-link" [routerLink]="['/season', s.guid]">
          <mat-icon>dashboard</mat-icon>
          <span>Overview</span>
        </a>
      }

      @if (sections()['date']) {
        <div class="atmos-season-card__row">
          <mat-icon>calendar_month</mat-icon>
          <span>
            <app-date-range [start]="s.date" [end]="s.endDate"></app-date-range>
            <span class="atmos-season-card__days">
              (<app-days-left [start]="s.date" [end]="s.endDate"></app-days-left>)
            </span>
          </span>
        </div>
      }

      @if (sections()['spirits'] && s.spirits.length) {
        <div class="atmos-season-card__row">
          <mat-icon>groups</mat-icon>
          <span>{{ s.spirits.length }} spirits</span>
        </div>
      }

      @if (sections()['cost'] && cost()) {
        <div class="atmos-season-card__cost">
          <app-cost [cost]="cost()" [remaining]="remainingCost()"></app-cost>
        </div>
      }

      @if (sections()['checkin']) {
        <app-daily-checkin
          [checkedIn]="checkedIn()"
          label="I have done my season dailies"
          (checkin)="onCheckin($event)"></app-daily-checkin>
      }

      <ng-content />
    </div>
  </article>
}
